import React, { useState, useEffect } from 'react';
import fileCacheService from '~/services/cache';

export default function CacheDebug() {
    const [showDebug, setShowDebug] = useState(false);
    const [cacheInfo, setCacheInfo] = useState({});

    const getCacheInfo = async () => {
        try {
            // Testar se o IndexedDB está funcionando
            const testUrl = 'https://apollo-media-production.s3.us-east-1.amazonaws.com/test/teste.png';
            const cachedUrl = await fileCacheService.getCachedUrl(testUrl, 'image');

            setCacheInfo({
                timestamp: new Date().toLocaleTimeString(),
                message: cachedUrl ? 'Cache funcionando - URL cacheados' : 'Cache ativo - baixando arquivos',
                dbStatus: 'IndexedDB OK'
            });
        } catch (error) {
            setCacheInfo({
                timestamp: new Date().toLocaleTimeString(),
                message: 'Erro no cache: ' + error.message,
                dbStatus: 'IndexedDB Error'
            });
        }
    };

    const clearCache = async () => {
        try {
            await fileCacheService.clearCache();
            alert('Cache limpo com sucesso!');
        } catch (error) {
            alert('Erro ao limpar cache');
        }
    };

    useEffect(() => {
        if (showDebug) {
            getCacheInfo();
            const interval = setInterval(getCacheInfo, 5000);
            return () => clearInterval(interval);
        }
    }, [showDebug]);

    // Só mostra em desenvolvimento
    if (process.env.NODE_ENV !== 'development') {
        return null;
    }

    return (
        <>
            <button
                onClick={() => setShowDebug(!showDebug)}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    background: '#007bff',
                    color: 'white',
                    border: 'none',
                    padding: '10px',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    zIndex: 10000
                }}
            >
                {showDebug ? 'Ocultar Cache Debug' : 'Mostrar Cache Debug'}
            </button>

            <div
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    background: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    padding: '10px',
                    borderRadius: '5px',
                    fontSize: '12px',
                    zIndex: 9999,
                    display: showDebug ? 'block' : 'none'
                }}
            >
                <div><strong>Cache Debug</strong></div>
                <div>{cacheInfo.message}</div>
                <div>{cacheInfo.dbStatus}</div>
                <div>{cacheInfo.timestamp}</div>
                <button onClick={clearCache} style={{ marginTop: '5px', fontSize: '10px' }}>
                    Limpar Cache
                </button>
            </div>
        </>
    );
}
